// Dependencies
import React, { Component } from 'react';

// Primereact imports
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';

// Multi lang
import { getLanguage, withTranslation } from 'react-multi-lang';

// Styling
import './cedula.scss';

// Utils
import { CEDULA_COM_ENTREGA_PRODUCT, CEDULA_SEM_ENTREGA_PRODUCT, MUDANCA_NOME_PROFISSIONAL_PRODUCT, PRODUCT_KEY_REASON } from '../../../common/constants';

// Redux
import { updateBasket } from '../../../redux/actions/order';
import { connect } from 'react-redux';
import { getReasonWithDeliveryList, getReasonWithoutDeliveryList } from '../../../common/lists/reason';

class CedulaComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            reason: null,
            validProduct: true,
            validReason: true,
            reasonDescription: "",
            validReasonDescription: null,
            showConfirmation: true,
        }
    }

    handleConfirmContinue() {
        this.setState({ showConfirmation: false });
    }

    handleConfirmExit() {
        this.props.onCancel();
    }

    updateFormComponent(column, value) {
        this.setState({
            [column]: value
        })
    }

    submitAcquisition() {
        if(this.validateForm()) {
            let metadata = [
                { key: PRODUCT_KEY_REASON, value: this.state.reason.code === "Outro" ? this.state.reasonDescription : this.state.reason.code }
            ];

            // Add product to basket
            let product = this.props.product;
            product.title = this.props.t("products.products." + product.title);
            product.metadata = metadata;

            let products = [];

            for (let i = 0; i < this.props.basketProducts.length; i++) {
                products.push(this.props.basketProducts[i]);
                
            }

            products.push(product);

            this.props.updateBasket(products, this.props.basketTrainings);
            this.props.onClose();
        }
    }

    validateForm() {
        let validProduct = true;

        for (let i = 0; i < this.props.basketProducts.length; i++) {
            if(this.props.product.productRef === CEDULA_SEM_ENTREGA_PRODUCT && (this.props.basketProducts[i].productRef === CEDULA_COM_ENTREGA_PRODUCT || this.props.basketProducts[i].productRef === MUDANCA_NOME_PROFISSIONAL_PRODUCT)) {
                validProduct = false;
                break;
            }

            if(this.props.product.productRef === CEDULA_COM_ENTREGA_PRODUCT && (this.props.basketProducts[i].productRef === CEDULA_SEM_ENTREGA_PRODUCT || this.props.basketProducts[i].productRef === MUDANCA_NOME_PROFISSIONAL_PRODUCT)) {
                validProduct = false;
                break;
            }
        }

        this.setState({
            validProduct: validProduct,
            validReason: this.state.reason !== null,
            validReasonDescription: this.state.reason !== null && (this.state.reason.code !== "Outro" || (this.state.reason.code === "Outro" && this.state.reasonDescription !== ""))
        });

        let validationResult = validProduct && (this.state.reason !== null &&
                               (this.state.reason !== null && (this.state.reason.code !== "Outro" || (this.state.reason.code === "Outro" && this.state.reasonDescription !== ""))));

        return validationResult;
    }

    render() {

        const REASON_LIST = this.props.product.productRef === CEDULA_SEM_ENTREGA_PRODUCT ?
            getReasonWithoutDeliveryList(getLanguage())
            :
            getReasonWithDeliveryList(getLanguage());

        const confirmHeader = (
            <div className="cedula-confirm-header">
                <i className="pi pi-exclamation-triangle cedula-confirm-icon"></i>
                <span>{this.props.t("products.labels.cedula-confirm-title")}</span>
            </div>
        );

        const confirmFooter = (
            <div className="cedula-confirm-footer">
                <Button label={this.props.t("products.labels.cedula-confirm-exit")} className="p-button-danger" onClick={() => this.handleConfirmExit()} />
                <Button label={this.props.t("products.labels.cedula-confirm-continue")} className="p-button-success" onClick={() => this.handleConfirmContinue()} />
            </div>
        );

        return (
            <>
            <Dialog visible={this.state.showConfirmation} style={{ width: '420px' }} header={confirmHeader} footer={confirmFooter} modal className="cedula-confirm-dialog" onHide={() => this.handleConfirmExit()}>
                <div className="cedula-confirm-body">
                    <h3>{this.props.t("products.labels.cedula-confirm-heading")}</h3>
                    <p>{this.props.t("products.labels.cedula-confirm-body")}</p>
                    <p>{this.props.t("products.labels.cedula-confirm-thanks")}</p>
                </div>
            </Dialog>
            <div className="grid mgt-10">
                <div className="col-12" style={{fontSize: "14px"}}>
                    <b>{this.props.t("products.labels.info-note")}</b>
                </div>
                <div className="col-12" style={{textAlign: "justify"}}>
                    <ul style={{marginLeft: "20px", padding: 0}}>
                    {
                        this.props.product.productRef === CEDULA_COM_ENTREGA_PRODUCT ?
                        <>
                            <li style={{marginBottom: "10px"}}>{this.props.t("products.labels.ballot-return")}</li>
                            <li>{this.props.t("products.labels.ballot-address")}</li>
                        </>
                        :
                        <>
                            <li style={{marginBottom: "10px"}}>{this.props.t("products.labels.ballot-address")}</li>
                        </>
                    }
                    </ul>
                </div>
                <div className="col-12" style={{fontSize: "14px"}}>
                    <b>{this.props.t("products.labels.product-form")}</b>
                </div>
                <div className="col-12" style={{marginTop: "10px"}}>
                    <div className="flex flex-column gap-2">
                        <label htmlFor="cedula">{this.props.t("products.labels.reason")}</label>
                        <Dropdown id="reason" value={this.state.reason} options={REASON_LIST} optionLabel="name" onChange={(evt) => this.updateFormComponent("reason", evt.value)}></Dropdown>
                        { this.state.validReason ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                        { this.state.validProduct ? null : <small className="p-error">{this.props.t("products.messages.invalid-ballot-request")}</small>  }
                    </div>
                    {
                        this.state.reason !== null && this.state.reason.code === "Outro" ?
                            <div className="flex flex-column gap-2 mgt-10">
                                <label htmlFor="reason-description">{this.props.t("products.labels.reason-detail")}</label>
                                <InputText value={this.props.reasonDescription} id="reason-description" type="text"  onChange={(evt) => this.updateFormComponent("reasonDescription", evt.target.value)}/>
                                { this.state.validReasonDescription ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                            </div>
                            : null
                    }
                </div>
                <div className='col-12 t-align-right'>
                    <div className="flex flex-wrap justify-content-end gap-2">
                        <Button label={this.props.t("products.labels.add")} icon="pi pi-shopping-cart" onClick={(evt) => this.submitAcquisition() } />
                    </div>
                </div>
            </div>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        basketProducts: state.store.basketProducts,
        basketTrainings: state.store.basketTrainings
    } 
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateBasket: (basketProducts, basketTrainings) => { dispatch(updateBasket(basketProducts, basketTrainings)) }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(CedulaComponent));